/* global http toggleEventsFilterModal */
const serviceFilterJobOffers = {
	el: {
		body: document.body,
		mainContainer: document.querySelector('.js-filter-jobs'),
		filterInputAndSelectListener: document.querySelectorAll('.js-filter-change-listener'),
		loadMoreButton: document.querySelector('.js-filter-loadmore-listener')
	},

	vars: {
		currentPage: 1
	},

	fxHandleFilterOnChangeSelectOrInput(el) {
		// check if element exists
		if (!el) return

		// reset pagination
		this.vars.currentPage = 1

		// Responsible for set values of radio buttons and select elements on data attribute called "data filter id" and make sure that when user select mobile version, the desktop version is selected as well
		toggleEventsFilterModal.fxHandleSelectAndInputValue(el)

		// filter results on change of radio button or select
		this.fxFilterRoutes(this.el.mainContainer)
	},

	fxUpdatePagination() {
		// increase the current page
		this.vars.currentPage += 1

		// filter results on pagination selected
		this.fxFilterRoutes(this.el.mainContainer)
	},

	fxRenderCards(response, data) {
		if (response.status === 200) {

			// this condition is needed to make sure that when user select a new filter, the results are filtered again
			if (this.vars.currentPage === 1) {
				// remove all the cards
				document.querySelectorAll('.cards-container__item').forEach(el => el.remove())
			}

			//set variables for later use
			let card

			//then we need to render the new results looping through the data
			data.items.map(el => {

				//save card structure in a variable
				card =
					`
					<div class='cards-container__item'	>
						<a class='card-beta' href='${el.url}'>
							<figure class='card-beta__figure'>
								<img class='card-beta__image img-full' src='${el.img}' alt='${el.title}'>
							</figure>
							<div class='card-beta__content'>
								<div class='card-beta__caption'>
									<span class='card-beta__caption-lead'>${el.location}</span>
								</div>
								<h2 class='card-beta__heading'>${el.title}</h2>
							</div>
						</a>
					</div>
				`
				// insert wrap container inside container (list-content__list) that is already in the DOM
				document.querySelector('.cards-container__grid').insertAdjacentHTML('beforeend', card)
			})

			if (!data.loadMore) {
				this.el.loadMoreButton.style.display = 'none'
			}
		}
	},

	fxGetSelectedFilterForSummaryResults(filterId) {
		// get selected filter type
		const typeSelected = document.querySelector(`[data-filter-type="${filterId}"`)
		// save which select option has been selected
		const optionSelected = typeSelected.querySelector('select').options.selectedIndex
		// return text from this option selected - this way we make sure that we return the exact same value as the one in select element
		return typeSelected.querySelector('select').options[optionSelected].text
	},

	fxRenderSummaryRouteResults(response, data) {
		if (response.status === 200) {

			// set the number of results with data.length
			document.querySelector('.js-filter-summary-counter').textContent = data.totalRecords

			// save variables for later use
			let filterRegion
			let filterLocation

			// populate variables 
			filterRegion = this.fxGetSelectedFilterForSummaryResults('region')
			filterLocation = this.fxGetSelectedFilterForSummaryResults('hostel')

			// set each result with variables created above
			document.querySelector('.js-filter-summary-first-selected').textContent = filterRegion
			document.querySelector('.js-filter-summary-second-selected').textContent = filterLocation
		}
	},

	fxGetFilterID(filterId) {
		// find filter type from parameter and get filter ID
		return document.querySelector(`[data-filter-type="${filterId}"`).getAttribute('data-filter-id')
	},

	fxFilterRoutes(el) {
		// check if element exists
		if (!el) return

		// set variables let (let it change)
		let filterRegion
		let filterHostel

		// populate variables
		filterRegion = this.fxGetFilterID('region')
		filterHostel = this.fxGetFilterID('hostel')

		// get endpoint
		const endpoint = el.getAttribute('data-action-job-cards')

		// get language that has to be sent to api
		const languageParameter = this.el.body.getAttribute('data-language')

		// set formData
		const formData = {
			region: filterRegion ? filterRegion : 'all',
			hostel: filterHostel ? filterHostel : 'all',
			page: this.vars.currentPage
		}

		// callback function 
		const callback = (response, data) => {
			// call function that will build cards
			this.fxRenderCards(response, data)

			// call function that will fill summary results
			this.fxRenderSummaryRouteResults(response, data)
		}

		// call api
		http.fxPost(endpoint, formData, callback, languageParameter)
	},

	events() {
		// check if element exists
		if (!this.el.mainContainer) return

		// Responsible for all events on select and radio buttons
		this.el.filterInputAndSelectListener.forEach(el => el.addEventListener('change', e => this.fxHandleFilterOnChangeSelectOrInput(e)))

		// Responsible for pagination 
		this.el.loadMoreButton && this.el.loadMoreButton.addEventListener('click', () => this.fxUpdatePagination())

		// Responsible for filter on load page
		this.fxFilterRoutes(this.el.mainContainer)
	},

	init() {
		this.events()
	}
}

serviceFilterJobOffers.init()